import React from 'react';
import {Link} from 'react-router-dom';
//import Upload from './upload/Uploads';
//import Modal from "./Modal";
//import {Can} from "../../ability-context";
import createLink from "../../libs/createLink";
import logo from "../../images/logo-white.png";

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleUpload: false,
        }
    }

    render() {
        return (
            <div id="footer">
                <img src={logo} alt={""} className={"logo"} />
                <div className="wrapper-footer">
                    <ul>

                        <li><Link to={createLink("parentalControl")}>Contrôle parental</Link></li>
                        <li><Link to={createLink("trustSecurity")}>Confiance et sécurité</Link></li>
                        <li><Link to={createLink("charter")}>Charte</Link></li>
                        <li><Link to={createLink("cgus")}>Conditions générales </Link></li>
                        {/*<li><Link to={createLink("history")}>Historique</Link></li>*/}
                        <li><Link to={createLink("contact")}>Contact</Link></li>
                        {/*<Can action={"upload"} subject="Media">
                            {can=>{
                                return can ? (
                                    <li className="cursor-pointer not-a-link"
                                        onClick={() => this.setState({toggleUpload: true})}>Envoyer une photo ou
                                        vidéo</li>
                                ) : (
                                    <li><Link to={createLink("signup")}>Créer un compte Voissa</Link></li>
                                )
                            }}
                        </Can>*/}
                    </ul>
                </div>

                {/*<Modal toggle={this.state.toggleUpload} handleClose={() => this.setState({toggleUpload: false})}>
                    <Upload handleClose={() => this.setState({toggleUpload: false})}/>
                </Modal>*/}
            </div>
        )
    }
}

export default Footer;
